// Bundle & Save codes (theme settings > Bundle & Save codes). The product page's 1 / 2 / 6 bars only show the savings;
// this puts the matching discount code on the cart so only shoppers on this theme get it (the live theme never runs it).
// Whenever the cart changes (any /cart/add|change|update|clear request, ours, the AOV drawer's or an app's) and on load:
// 6+ items tries the 6 code, then the 2 code; 2+ items tries the 2 code; fewer removes both. Shopify decides whether a
// code really applies (minimum quantity, eligible products), so a code that comes back not applicable is taken off again.
// Other codes on the cart (a popup code, the drawer's free shipping code) are kept, and a bundle code is only kept
// when it doesn't knock one of them out, unless it saves more than they did.
(() => {
  const CC = window.CC || {};
  const BC = CC.bundleCodes;
  // off in the theme editor, where it would change the merchant's own cart and reload the cart preview
  if (!BC || !(BC.two || BC.six) || (window.Shopify && window.Shopify.designMode)) return;
  const root = ((CC.routes && CC.routes.root) || '/').replace(/\/$/, '');
  const low = (s) => String(s || '').toLowerCase();
  const ours = [BC.two, BC.six].filter(Boolean).map(low);
  const isOurs = (code) => ours.includes(low(code));
  const CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const origFetch = window.fetch.bind(window);
  const json = { Accept: 'application/json', 'Content-Type': 'application/json' };

  const getCart = () => origFetch(root + '/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());
  const setCodes = (codes) => origFetch(root + '/cart/update.js', {
    method: 'POST', headers: json, credentials: 'same-origin', body: JSON.stringify({ discount: codes.join(',') })
  }).then((r) => r.json());
  const find = (cart, code) => (cart.discount_codes || []).find((d) => low(d.code) === low(code));
  const lostOthers = (before, after, others) => others.some((c) => {
    const b = find(before, c), a = find(after, c);
    return b && b.applicable && !(a && a.applicable);
  });

  // Codes Shopify turned down for this exact cart (e.g. 6 items but a gift message among them), kept for the
  // visit so we don't strip and re-try them on every page view or cart change.
  const store = (() => { try { return window.sessionStorage; } catch (e) { return null; } })();
  const sigOf = (cart) => (cart.items || []).map((i) => i.key + ':' + i.quantity).sort().join('|');
  const failedFor = (sig) => {
    try { const f = JSON.parse((store && store.getItem('cc-bc-failed')) || 'null'); return f && f.sig === sig ? f.codes : []; } catch (e) { return []; }
  };
  const remember = (sig, codes) => { try { store && store.setItem('cc-bc-failed', JSON.stringify({ sig, codes })); } catch (e) {} };
  const applied = (cart) => (cart.discount_codes || []).filter((d) => d.applicable).map((d) => low(d.code)).sort().join(',');

  async function sync() {
    const cart = await getCart();
    const codes = cart.discount_codes || [];
    const others = codes.map((d) => d.code).filter((c) => !isOurs(c));
    const mine = codes.filter((d) => isOurs(d.code));
    const n = cart.item_count || 0;
    const sig = sigOf(cart), failed = failedFor(sig);
    const tries = (n >= 6 ? [BC.six, BC.two] : n >= 2 ? [BC.two] : []).filter((c) => c && !failed.includes(low(c)));
    if (!tries.length && !mine.length) return false;
    // already on the best code that can apply
    if (mine.length === 1 && mine[0].applicable && low(mine[0].code) === low(tries[0])) return false;
    const before = applied(cart);

    const base = mine.length ? await setCodes(others) : cart;
    let last = base;
    for (const code of tries) {
      last = await setCodes(others.concat(code));
      const d = find(last, code);
      if (d && d.applicable && (!lostOthers(base, last, others) || last.total_discount > base.total_discount)) {
        remember(sig, failed);
        return applied(last) !== before;
      }
      failed.push(low(code));
    }
    remember(sig, failed);
    // nothing applied: leave the cart with just the other codes
    if (tries.length) last = await setCodes(others);
    return applied(last) !== before;
  }

  let running = false, again = false, timer;
  const refresh = () => {
    document.dispatchEvent(new CustomEvent('cc:bundle-codes'));
    // the /cart page is server-rendered: reload it to show the new prices, but never twice for the same cart
    if (document.body.classList.contains('cc-tpl-cart')) {
      getCart().then((c) => {
        const key = sigOf(c) + '#' + applied(c);
        let seen = null; try { seen = store && store.getItem('cc-bc-reload'); } catch (e) {}
        if (seen === key) return;
        try { store && store.setItem('cc-bc-reload', key); } catch (e) {}
        location.reload();
      }).catch(() => {});
      return;
    }
    if (typeof window.aovCartDrawerUpdate === 'function') { try { window.aovCartDrawerUpdate(); } catch (e) {} }
  };
  const run = async () => {
    if (running) { again = true; return; }
    running = true;
    let changed = false;
    try { changed = await sync(); } catch (e) {}
    running = false;
    if (again) { again = false; run(); return; }
    if (changed) refresh();
  };
  const schedule = () => { clearTimeout(timer); timer = setTimeout(run, 250); };

  // watch every cart request on the page (our own calls use origFetch, so they don't trigger this)
  window.fetch = function (input, init) {
    const p = origFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (method === 'POST' && CART_RE.test(url)) p.then(schedule, () => {});
    } catch (e) {}
    return p;
  };
  const open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (String(method).toUpperCase() === 'POST' && CART_RE.test(String(url))) this.addEventListener('loadend', schedule);
    return open.apply(this, arguments);
  };

  schedule();
})();
